import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import { useAtom } from 'jotai';
import { useState } from 'react';

import styles from './styles.module.scss';
import { amountAtom } from '../../../_shared/atoms/prepaidCardAtoms';
import { nameAtom } from '../../atoms/purchasePrepaidCardAtoms';

const AVAILABLE_AMOUNTS = [1, 2, 3, 5];

function CardInfo() {
  const [amount, setAmount] = useAtom(amountAtom);
  const [name, setName] = useAtom(nameAtom);
  const [isManual, setIsManual] = useState(false);
  return (
        <Column className={styles.container}
                fullWidth
                as='section'
                spacing={12}>
            <Text size='2xl' fontWeight='bold' color={colors.gray7}
                  className={styles.title} >
                카드 별명
            </Text>
            <Text size='lg' fontWeight='bold' color={colors.gray7}>
                나만의 카드 별명을입력해주세요
            </Text>
            <TextField value={name}
                       onChange={(e) => setName(e.target.value)} />
            <Text size='s' fontWeight='bold' color={colors.gray5}>
                카드별명은 구매 후 ‘카드 관리’ 에서도 변경 가능합니다.
            </Text>
            <Text size='2xl' fontWeight='bold' color={colors.gray7}
                  className={styles.title} >
                구매금액
            </Text>
            <Chip.Container>
                {AVAILABLE_AMOUNTS.map((availableAmount) => (
                    <Chip isSelected={availableAmount * 10000 === amount && !isManual}
                                key={`amount-${availableAmount}`}
                                onClick={() => {
                                  setAmount(availableAmount * 10000);
                                  setIsManual(false);
                                }} >
                        {availableAmount}만원
                    </Chip>
                ))}
                <Chip isSelected={isManual}
                      onClick={() => setIsManual(true)} >
                    자유 입력
                </Chip>
            </Chip.Container>
            {isManual && (
                <TextField placeholder='금액 입력'
                           // @ts-ignore
                           type='number'
                           className={styles.manual}
                           step={1000}
                           min={10000}
                           value={amount.toString()}
                           setValue={(v) => setAmount(Math.min(Number(v), 500000))}
                           inputMode='numeric' />
            )}
        </Column>
  );
}

export default CardInfo;
